import { analytics } from '../../firebase';
import { logEvent as fbLogEvent } from 'firebase/analytics';

export default function logEvent(name: string, params: { [key: string]: unknown } = {}) {
    return fbLogEvent(analytics, name, params);
}
